export default __webpack_public_path__ + "static/media/matrix.0fc904a9.svg";